/* eslint-disable @typescript-eslint/explicit-function-return-type */
import axios from "axios";

const token = (): string =>
  localStorage.getItem("tokens") ?? sessionStorage.getItem("tokens") ?? "";
export const getAccessToken = (): string => {
  try {
    return JSON.parse(token()).access_token;
  } catch (e) {
    return "";
  }
};

const UNAUTHORIZED_ERROR_CODE = 401;

// const insightsURL = process.env.REACT_APP_INSIGHTS_API_URL ?? ""
const insightsURL = "https://qa.api.insights.cropwise.com";
const insightsVersion = process.env.REACT_APP_INSIGHTS_API_VERSION ?? "";
const insightsBaseURL = `${insightsURL}/${insightsVersion}`;
export const InsigtsAPIAxiosInstance = axios.create({
  baseURL: insightsBaseURL,
  headers: {
    "Cache-Control": "no-cache",
    Authorization: `Bearer ${getAccessToken()}`,
  },
});

InsigtsAPIAxiosInstance.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${getAccessToken()}`;
    return config;
  },
  async function (error) {
    return await Promise.reject(new Error(error));
  }
);
InsigtsAPIAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === UNAUTHORIZED_ERROR_CODE) {
      //   authService.getAccessToken();
      // void logout();
    }
  }
);

export default InsigtsAPIAxiosInstance;
